import { render, staticRenderFns } from "./client-archive.vue?vue&type=template&id=3057ec7f&scoped=true&"
import script from "./client-archive.vue?vue&type=script&lang=ts&"
export * from "./client-archive.vue?vue&type=script&lang=ts&"
import style0 from "./client-archive.vue?vue&type=style&index=0&id=3057ec7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057ec7f",
  null
  
)

component.options.__file = "client-archive.vue"
export default component.exports